import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {DealActivityDealItem, Hub, isDealActivityDealItem} from 'yougile-model'
import {cn} from '../../containers/html-utils'
import {Icon} from '../common/base/icon'
import {createOnClickDeal} from '../crm-activities-view/activities-data/create-on-click-deal'
import {customFormatDate} from '../crm-activities-view/custom-format-date'
import {getDealActivityColors} from '../crm-activities-view/get-deal-activity-color'
import {getDealActivity} from '../right-panel/crm/deal-history/get-deal-activity'

const TwContainer = tw.div`

  flex
  items-center
  gap-4
  mt-12
  mx-[-8px]
  mb-[-8px]
  p-12
  cursor-pointer
`

interface DealActivityCardProps {
  deal: Hub
}

export const DealActivityCard = ({deal}: DealActivityCardProps) => {
  let content = null
  const activity = getActivityWithMinDeadline(deal)
  let color: {text: string; bg: string} | undefined

  if (activity) {
    const deadline = customFormatDate(activity.deadline, false)
    color = getDealActivityColors(activity)

    content = (
      <>
        <Icon icon="IconCustomBolt" className={color.text} />
        {deadline}
      </>
    )
  } else {
    content = (
      <>
        <Icon icon="IconCustomPlus" className={'text-sticker-orange'} />
        {Lang.msg.crm.board.addDealActivity}
      </>
    )
  }

  const shouldHandleOnClick = !activity
  const onClickAddDeal = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    e.preventDefault()
    createOnClickDeal(deal, activity)?.()
  }

  return (
    <TwContainer
      className={cn(
        activity
          ? `${color?.text} ${color?.bg}`
          : 'bg-sticker-orange text-sticker-orange justify-center ml-[-28px]'
      )}
      onClick={shouldHandleOnClick ? onClickAddDeal : undefined}
    >
      {content}
    </TwContainer>
  )
}

const getActivityWithMinDeadline = (
  hub: Hub
): DealActivityDealItem | undefined => {
  let activityWithMinDeadline: DealActivityDealItem | undefined

  for (const activity of getDealActivity(hub) ?? []) {
    if (!isDealActivityDealItem(activity)) {
      continue
    }
    if (activity.completed) {
      continue
    }

    if (activity.deadline < (activityWithMinDeadline?.deadline ?? Infinity)) {
      activityWithMinDeadline = activity
    }
  }

  return activityWithMinDeadline
}
